
// USAGE:
// - Add data-search-name to input searchfield as well as className .dropdown-search
// - Add class .SearchItem to search items

$(function () {

    //Prevents dropdown from closing when clicking on the search input field
    $(".dropdown-search").on("click", function (event) {
        event.stopImmediatePropagation();
    });

    $(".dropdown-search").on("change keyup paste", function () {
        var elem = $(this);
        var searchVal = $(elem).val().toString().toLowerCase();
        dropdownSearch(elem, searchVal);
    });

    function dropdownSearch(elem, searchVal) {
        var closestDropdown = $(elem).closest(".dropdown-menu");
        var searchItems = closestDropdown.find(".dropdown-search-item");
        if (searchItems !== undefined && searchItems.length > 1) {
            searchItems.each(function () {
                if ($(this).find("a").text().toLowerCase().indexOf(searchVal) !== -1 && searchVal !== "") {
                    $(this).show();
                }
                else if (searchVal === "") {
                    $(this).show();
                } else {
                    $(this).hide();
                }
            });
        }
    }

    //Reset Search Value
    $(document).on("mousedown touchend", function (e) {
        $(".dropdown").each(function () {
            if (!$(this).hasClass("open")) {
                var dropdownInput = $(this).find(".dropdown-search");
                if (dropdownInput.val() !== "") {
                    dropdownInput.val("");
                    dropdownSearch(dropdownInput, "");
                }
            }
        });
    });
});